import { SxProps, Theme } from '@mui/material';

export const tableContainerStyles: SxProps<Theme> = {
  width: '100%',
  bgcolor: 'background.paper',
  borderRadius: 1,
};

export const tableHeaderStyles: SxProps<Theme> = {
  p: 1.5,
  backgroundColor: 'background.paper',
  fontWeight: 'bold',
  fontSize: '1.1rem',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const dataGridStyles: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  '& .MuiDataGrid-row': {
    backgroundColor: 'background.paper',
    '&:nth-of-type(odd)': {
      backgroundColor: 'action.hover',
    },
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  '& .MuiDataGrid-cell': {
    padding: '4px 8px',
    whiteSpace: 'normal',
    borderBottom: 'none',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: 'background.paper',
    borderBottom: '1px solid',
    borderColor: 'divider',

  },
  '& .MuiDataGrid-columnHeaderTitle': {
      whiteSpace: 'normal',
      lineHeight: 1.2,
      wordWrap: 'break-word',
      textAlign: 'left',
  },
  '& .MuiDataGrid-footerContainer': {
    backgroundColor: 'background.paper',
    borderTop: '1px solid',
    borderColor: 'divider',
  },
  border: 'none',
  maxHeight: '50vh',
  minHeight: '50vh',
};
